window.TravelMrMrsSmith = (function ($, components) {
    window.dataLayer = window.dataLayer || [];
    const self = {
        func: {
            init: function () {
                self.func.bindings();
            },
            bindings: function () {
                $(components.ComplianceInformation.Elements.Buttons.SignUpButton).on('click', self.func.handleSignUpButtonClick);
            },
            handleSignUpButtonClick: function () {
                if (components.ComplianceInformation.Func.IsSignUpButtonEnabled()) {
                    components.ComplianceInformation.Func.SwitchToPleaseWaitButton();
                }
            }
        }
    };

    return {
        init: self.func.init
    };
})(jQuery, {ComplianceInformation: ComplianceInformation});

$('document').ready(function () {
    if ('mrmrssmith' === $('#page-data').data('feature')) {
        if ('False' === $('#page-data').data('iseligible')) {
            const element = $('.vds-partner-header__cta-container .vds-partner-header__button-primary');
            $(element).removeAttr('href');
            $(element).removeClass();
            $(element).addClass('vds-button vds-button--disabled vds-button vds-cta-block__button vds-partner-header__button');
        }
        window.TravelMrMrsSmith.init();
    }
});
